// React/t4r-ljd-ui/src/utils/addMLUsToWooCommerceCart.js

/**
 * Phase B - Convert MLU codes to WooCommerce product IDs
 * Reads the CSV mapping file and returns a lookup dictionary.
 * @returns {Promise<Object>} A dictionary mapping MLU Codes to product IDs.
 */
export async function loadMLUMapping() {
  try {
    const response = await fetch('/twin4resilience_wordpress_mapping.csv');
    if (!response.ok) {
        throw new Error(`Failed to fetch mapping CSV: ${response.statusText}`);
    }
    const csvText = await response.text();
    const lines = csvText.split('\n').filter(line => line.trim() !== '');
    
    const mapping = {};
    // Skip the header row (index 0)
    for (let i = 1; i < lines.length; i++) {
        const row = lines[i];
        const splits = row.split(',');
        
        // MLU Code is always just before the last column, Product ID is the last column.
        if (splits.length >= 3) {
            const idRaw = splits[splits.length - 1].replace(/['"\r]/g, '').trim();
            const codeRaw = splits[splits.length - 2].replace(/['"\r]/g, '').trim();
            
            const id = parseInt(idRaw, 10);
            if (!isNaN(id) && codeRaw) {
                mapping[codeRaw] = id;
            }
        }
    }
    return mapping;
  } catch (error) {
      console.error("Error loading MLU mapping:", error);
      return {};
  }
}

/**
 * Maps MLU codes to WooCommerce IDs.
 * Rules: Ignore missing mappings, remove duplicates, preserve origin order.
 * @param {Array<string>} selectedCodes 
 * @param {Object} mappingDict 
 * @returns {Array<number>} 
 */
export function mapMLUCodesToProductIDs(selectedCodes, mappingDict) {
    if (!selectedCodes || !Array.isArray(selectedCodes)) return [];
    
    const ids = [];
    const seen = new Set();
    
    for (const code of selectedCodes) {
        if (mappingDict[code]) {
            const id = mappingDict[code];
            if (!seen.has(id)) {
                seen.add(id);
                ids.push(id);
            }
        }
    }
    return ids;
}


